import { Link } from "react-router-dom";
import { WifiOff, HardDriveDownload, RefreshCw, ArrowLeft } from "lucide-react";

export default function OfflineDelivery() {
    return (
        <main className="min-h-screen bg-gradient-to-b from-indigo-700 via-indigo-600 to-violet-600 px-6 py-12 flex justify-center">
            <div className="w-full max-w-5xl bg-white rounded-2xl shadow-xl p-8">
                <div className="flex items-center gap-3 mb-6">
                    <img src="/Images/ExamsPro.png" alt="ExamsPro" className="w-10 h-10" />
                    <h1 className="text-2xl font-bold text-indigo-700">Offline Delivery</h1>
                </div>

                <p className="text-gray-600 mb-8">
                    Deliver exams without reliable internet. Data syncs automatically when connectivity returns.
                </p>

                <section className="grid md:grid-cols-3 gap-6">
                    <div className="rounded-xl border border-indigo-100 p-6">
                        <div className="flex items-center gap-2 mb-3 text-indigo-700">
                            <WifiOff className="w-5 h-5" />
                            <h3 className="font-semibold">Air-gapped Mode</h3>
                        </div>
                        <p className="text-gray-700 text-sm">Encrypted local cache, secure kiosk profiles.</p>
                    </div>

                    <div className="rounded-xl border border-indigo-100 p-6">
                        <div className="flex items-center gap-2 mb-3 text-indigo-700">
                            <HardDriveDownload className="w-5 h-5" />
                            <h3 className="font-semibold">Pre-load Content</h3>
                        </div>
                        <p className="text-gray-700 text-sm">Download exams, media, and keys to devices ahead of time.</p>
                    </div>

                    <div className="rounded-xl border border-indigo-100 p-6">
                        <div className="flex items-center gap-2 mb-3 text-indigo-700">
                            <RefreshCw className="w-5 h-5" />
                            <h3 className="font-semibold">Resilient Sync</h3>
                        </div>
                        <p className="text-gray-700 text-sm">Retry queues and conflict resolution protect results.</p>
                    </div>
                </section>

                <div className="mt-8 flex flex-wrap gap-3">
                    <Link to="/support/contact" className="bg-indigo-600 text-white px-4 py-2 rounded-md hover:bg-indigo-700">Plan a Pilot</Link>
                    <Link
                        to="/solutions/examspro"
                        className="inline-flex items-center gap-2 bg-indigo-100 text-indigo-700 hover:bg-indigo-200 hover:text-indigo-800 px-5 py-2.5 rounded-full font-semibold transition shadow-sm"
                    >
                        <ArrowLeft className="w-4 h-4" />
                        Back to ExamsPro
                    </Link>
                </div>
            </div>
        </main>
    );
}
